import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ResponseStatus} from "../../actions/types";
import userAddressesService from "../../services/user-addresses.service";
import {UserAddress} from "../../pages/shared/models/user/user-address";
import {handleGetMyAddresses, onPaginationChange} from "../reducers/user-addresses.reducer";

export const getMyAddresses = createAsyncThunk(
    'getMyAddresses',
    async (props :{forceLoad?: boolean, page?: number}, thunkApi) => {
        try {
            const addresses = await userAddressesService.getMyAddresses(props.page);
            return {myAddresses: addresses}
        } catch (error) {
            return {
                access_token: null,
                errors: thunkApi.rejectWithValue(error)
            }
        }},
        {
            condition(props :{forceLoad?: boolean, page?: number}, {getState}): boolean {
            const allSliceStates = getState() as {[key: string]: any};
            const userAddressesSlice = allSliceStates['userAddressesReducer'];

            return props.forceLoad || !(userAddressesSlice.myAddressesData.addresses && userAddressesSlice.myAddressesData.addresses.length);
        }
    }
)

export const userAddressesSlice = createSlice({
    name: "userAddresses",
    initialState: {
        myAddressesData: {
            addresses: [] as UserAddress[],
            currentPage: 0,
            pageSize: 10,
            totalItems: 0,
        } ,
        errors: [],
        isLoading: false,
    } as UserAddressesSliceData,
    reducers: {
        changePagination: onPaginationChange
    },
    extraReducers: (builder) => {
        builder.addCase(getMyAddresses.pending, state => handleGetMyAddresses(state, ResponseStatus.PENDING, null));
        builder.addCase(getMyAddresses.fulfilled, (state, action) => handleGetMyAddresses(state, ResponseStatus.SUCCESS, action.payload));
        builder.addCase(getMyAddresses.rejected, (state, action) => handleGetMyAddresses(state, ResponseStatus.FAIL, action.payload));
    }
})

export interface UserAddressesSliceData {
    myAddressesData: {
        addresses: UserAddress[],
        currentPage: number,
        pageSize: number,
        totalItems: number,
    },
    errors: any[],
    isLoading: boolean,
}

export default userAddressesSlice.reducer;
export const {changePagination} = userAddressesSlice.actions;
